






























































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class Home extends Vue {
  public activeMenu = "";
  public imgList = [
    {
      id: 1,
      url: require("@/assets/imgs/wx.png"),
      url_src: require("@/assets/imgs/wx.jpg")
    },
    {
      id: 2,
      url: require("@/assets/imgs/qq.png"),
      url_src: require("@/assets/imgs/qq.jpg")
    },
    {
      id: 3,
      url: require("@/assets/imgs/wb.png"),
      url_src: require("@/assets/imgs/wb.jpg")
    }
  ];
  public List = [
    {
      content: "商务合作"
    },
    {
      content: "关于我们"
    },
    {
      content: "招贤纳士"
    },
    {
      content: "悟饭公告"
    }
  ];
  public linkList = [
    {
      name: "鸡你太美"
    },
    {
      name: "生化危机官网"
    },
    {
      name: "果仁iphone模拟器"
    },
    {
      name: "快吧游戏"
    },
    {
      name: "游戏堡"
    },
    {
      name: "牛游戏"
    },
    {
      name: "末日之光官网"
    },
    {
      name: "悟饭游戏社区"
    },
    {
      name: "玩游戏网"
    },
    {
      name: "西游释厄传"
    },
    {
      name: "逃离外婆家攻略大全"
    },
    {
      name: "逃离外婆家下载"
    },
    {
      name: "悟饭阅读"
    },
    {
      name: "悟饭看点"
    },
    {
      name: "悟饭知道"
    },
    {
      name: "月华剑士"
    },
    {
      name: "变身忍者"
    },
    {
      name: "生化危城"
    },
    {
      name: "热血系列游戏"
    },
    {
      name: "口袋妖怪 漆黑的魅影5.0EX BW"
    },
    {
      name: "龙珠大冒险"
    },
    {
      name: "圣火徽章外传"
    },
    {
      name: "雪人兄弟免费下载"
    },
    {
      name: "NEO炸弹人"
    },
    {
      name: "游聚游戏平台"
    },
    {
      name: "街机中国"
    },
    {
      name: "XY游戏"
    },
    {
      name: "手心游戏"
    },
    {
      name: "悟饭游戏厅最新电脑版"
    },
    {
      name: "手游排行榜"
    },
    {
      name: "游戏吧"
    },
    {
      name: "兔玩电竞"
    },
    {
      name: "手机游戏"
    },
    {
      name: "九啦啦小游戏"
    },
    {
      name: "啪啪游戏厅"
    },
    {
      name: "悟饭FAQ"
    },
    {
      name: "悟饭金手指大全"
    },
    {
      name: "苹果软件园"
    },
    {
      name: "楼兰小说"
    },
    {
      name: "优游手游下载"
    },
    {
      name: "魔兽地图下载"
    },
    {
      name: "五四互娱"
    },
    {
      name: "手游下载"
    }
  ];
}
